import { hyperdbTriggers } from 'hyperdb-utils';
import httpRequest from '../../../helpers/httpRequest';
import upload from '../../../helpers/upload';
import * as config from '../../../../config';

const triggers = hyperdbTriggers({ config,
  namespace: 'EMAIL_PROPERTY_DATA',
  entryPoint: '/email-property-datas',
  collectionName: 'email_property_datas',
  querySearchListing: [
    ['name', ['email_data', ['id'] ]],
    { order: { id: 'asc' } }
  ],
  successMessageCreate: 'Property data created',
  successMessageUpdate: 'Property data updated',
  successMessageDelete: 'Property data deleted',
});

export default {
  ...triggers,
  savePdf(dispatch, getState, { propertyDataId, pdf, locale }) {
    const { payload, ...data } = pdf;
    const params = data.value ? data : {
      $type: 'file',
      value: {
        name: data.filename || payload.name,
        content_type: payload.type,
        size: payload.size,
        mtime: (new Date(payload.lastModified || 0)).toISOString(),
      }
    };
    const url = config.APP_URL + `/email-property-datas/${propertyDataId}/upload-pdf`;
    dispatch({ type: 'EMAIL_PROPERTY_DATA__UPLOAD_PDF' });
    return upload(url, { ...params, file: payload, locale})
      .then(savedPdf => {
        dispatch({ type: 'EMAIL_PROPERTY_DATA__UPLOAD_PDF_SUCCESS', payload: savedPdf });
      })
      .catch(err => {
        dispatch({ type: 'EMAIL_PROPERTY_DATA__ERROR', payload: err });
      });
  },
  deletePdf(dispatch, getState, { propertyDataId, locale }) {
    const url = config.APP_URL + `/email-property-datas/${propertyDataId}/delete-pdf?locale=${locale}`;
    dispatch({ type: 'EMAIL_PROPERTY_DATA__DELETE_PDF' });
    return httpRequest('DELETE', url)
      .then(() => {
        dispatch({ type: 'EMAIL_PROPERTY_DATA__DELETE_PDF_SUCCESS' });
      })
      .catch(err => {
        dispatch({ type: 'EMAIL_PROPERTY_DATA__ERROR', payload: err });
      });
  },
};



// WEBPACK FOOTER //
// ./src/frontend/modules/email/property-data/triggers.js